module.exports = __webpack_public_path__ + "static/media/slide_three.ddd7f5b0.jpg";